import { DataEmoji } from '../../dataUtils/DataTypes'
import { emojiNames } from '../../dataUtils/emojiNames'
import { emojiHasVariations } from '../../dataUtils/emojiVariations'

import { BaseEmojiProps } from './BaseEmojiProps'
import { ClickableEmojiButton } from './ClickableEmojiButton'
import { ViewOnlyEmoji } from './ViewOnlyEmoji'

type ClickableEmojiProps = Readonly<
  BaseEmojiProps & {
    hidden?: boolean
    showVariations?: boolean
    hiddenOnSearch?: boolean
    emoji: DataEmoji
    className?: string
    noBackground?: boolean
  }
>

export function ClickableEmoji({
  emoji,
  unified,
  hidden,
  hiddenOnSearch,
  emojiStyle,
  showVariations = true,
  size,
  lazyLoad,
  getEmojiUrl,
  className,
  noBackground = false,
}: ClickableEmojiProps) {
  const hasVariations = emojiHasVariations(emoji)

  return (
    <ClickableEmojiButton
      hasVariations={hasVariations}
      showVariations={showVariations}
      hidden={hidden}
      hiddenOnSearch={hiddenOnSearch}
      emojiNames={emojiNames(emoji)}
      unified={unified}
      noBackground={noBackground}
    >
      <ViewOnlyEmoji
        unified={unified}
        emoji={emoji}
        size={size}
        emojiStyle={emojiStyle}
        lazyLoad={lazyLoad}
        getEmojiUrl={getEmojiUrl}
        className={className}
      />
    </ClickableEmojiButton>
  )
}
